<div class="modal-header">
    <h4 class="modal-title"><strong>Estrategia {{ data.strategy.name }} - Preproyecto</strong></h4>
    <button type="button" class="btn-close" mat-dialog-close></button>
</div>
<mat-dialog-content style="max-height: 70vh">
    <div class="modal-body">
        <mat-divider></mat-divider>

        <!-- Franja de aviso cuando se detectan cambios en la distribución -->
        <div class="alert alert-danger d-flex align-items-center mb-3 mt-2" role="alert" *ngIf="review">
            <mat-icon class="me-2 flex-shrink-0">warning</mat-icon>
            <div>
                <strong>Atención:</strong> Se actualizó la distribución y se detectaron cambios en los materiales de esta estrategia. Es necesario generar o solicitar un nuevo folio para procesar un nuevo preproyecto.
            </div>
        </div>

        <div class="row borderMdl"> 
            <div class="col mb-3 mt-2">

                <!-- ARTES -->
                <div *ngIf="flagArtesPreproyecto" id="divArtes">

                    <div class="container-fluid p-3">

                        <div class="row g-4">
                        
                            <div class="col-12 col-md-3">
                                <div *ngFor="let doc of documents" class="card-sidebar mb-3 p-3 rounded-3 border" style="cursor: pointer"
                                    [class.selected]="selectedDocument.id === doc.id_archivo" (click)="selectDocument(doc)">
                        
                                    <div class="d-flex align-items-center justify-content-between mb-1">
                                        <span class="document-name-truncate fw-bold text-dark" [matTooltip]="doc.nombre_archivo">{{ doc.nombre_archivo }}</span>
                                    </div>
                                    <div class="text-muted small">
                                        {{ doc.matches?.length || 0 }}
                                        {{ (doc.matches?.length || 0) === 1 ? 'match' : 'matches' }}
                                    </div>
                                </div>
                            </div>

                            <div class="col-12 col-md-9 border-start ps-4" *ngIf="selectedDocument">
                                <!-- Encabezado del detalle -->
                                <div class="d-flex align-items-center gap-2 mb-4">
                                    <h3 class="selected-document-title fw-bold mb-0" [matTooltip]="selectedDocument.nombre_archivo">{{ selectedDocument.nombre_archivo }}</h3>                                    
                                    <button mat-flat-button color="primary" class="ms-3" (click)="openDialogArte(selectedDocument.archivo)">Ver arte ({{ selectedDocument.paginas }} pág.)</button>
                                    <button mat-flat-button color="primary" (click)="openDialogHistorial(selectedDocument.id_sku,selectedDocument.ancho,selectedDocument.alto,selectedDocument.id_family,selectedDocument.family)">Historial</button>
                                    <mat-slide-toggle
                                        *ngIf="hasProductWithEvenTintas()"
                                        class="ms-3"
                                        color="primary"
                                        [disabled]="completed"
                                        [checked]="selectedDocument.f_igual_v"
                                        (change)="confirmFigualvChange($event.checked)">
                                         Frente = vuelta
                                    </mat-slide-toggle>
                                </div>
                                
                                <!-- Filtros / Acciones secundarias (ocultos al completarse la estrategia) -->
                                <div class="d-flex justify-content-between align-items-center mb-4" *ngIf="!completed">
                                    <div class="d-flex align-items-center">
                                        <span class="me-3">Matches:</span>
                                
                                        <div class="match-toggle d-flex align-items-center gap-2">
                                            <span class="match-option" [class.active]="selectedDocument.type_match === 1">
                                                Global
                                            </span>
                                
                                            <mat-slide-toggle color="primary" [checked]="selectedDocument.type_match === 2" (click)="confirmStructureChange($event)"></mat-slide-toggle>
                                
                                            <span class="match-option" [class.active]="selectedDocument.type_match === 2">
                                                Por página
                                            </span>
                                        </div>

                                        <button *ngIf="selectedDocument.type_match === 1" mat-flat-button color="accent" class="ms-4"
                                            matTooltip="Añadir match" [matTooltipPosition]="'right'" (click)="addMatch(selectedDocument)">
                                            <mat-icon>add</mat-icon>
                                        </button>

                                        <div *ngIf="selectedDocument.type_match === 2" class="version-bulk-controls ms-4">
                                            <mat-form-field appearance="outline" class="version-start-field">
                                                <mat-label>Versión desde:</mat-label>
                                                <input matInput type="number" min="0" step="1" [(ngModel)]="versionDesde">
                                            </mat-form-field>
                                            <button mat-flat-button color="accent" [disabled]="!isValidStartingVersion()"
                                                (click)="assignConsecutiveVersions()">
                                                Consecutivas
                                            </button>
                                            <button mat-flat-button color="accent" [disabled]="!isValidStartingVersion()"
                                                (click)="assignSameVersionToAll()">
                                                Misma a todas
                                            </button>
                                            <button mat-flat-button color="primary" class="ms-2"
                                                (click)="validarTodoMasivo(selectedDocument)"
                                                matTooltip="Envía a Enfocus todas las páginas sin validar">
                                                Validar todo <mat-icon class="ms-1">fact_check</mat-icon>
                                            </button>
                                        </div>
                                    </div>
                                
                                    <mat-slide-toggle
                                        color="primary"
                                        [checked]="selectedDocument.mostrar_accesorios"
                                        (change)="selectedDocument.mostrar_accesorios = $event.checked">
                                        {{ selectedDocument.mostrar_accesorios
                                            ? 'Ocultar accesorios'
                                            : 'Mostrar accesorios' }}
                                    </mat-slide-toggle>
                                </div>

                                <div class="table-responsive preproject-matches-table">
                                    <table class="table align-middle mb-0">
                                        <thead>
                                            <tr class="text-muted small text-uppercase">
                                                <th scope="col">Nombre OP</th>
                                                <th scope="col">Nombre Layout</th>
                                                <th scope="col">Layout</th>
                                                <th scope="col">Producto</th>
                                                <th *ngIf="selectedDocument.mostrar_accesorios" scope="col" class="text-center">Acc. 1</th>
                                                <th *ngIf="selectedDocument.mostrar_accesorios" scope="col">&nbsp;</th>
                                                <th *ngIf="selectedDocument.mostrar_accesorios" scope="col" class="text-center">Acc. 2</th>
                                                <th *ngIf="selectedDocument.mostrar_accesorios" scope="col">&nbsp;</th>
                                                <th *ngIf="selectedDocument.type_match === 2" scope="col" class="text-center version-column">Versión</th>
                                                <th class="text-center" scope="col">Acciones</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <ng-container *ngFor="let match of selectedDocument.matches; let i = index">
                                                <tr [class.child-match-row]="match.is_child_row">
                                                    <td *ngIf="selectedDocument.type_match === 2" [attr.colspan]="selectedDocument.mostrar_accesorios ? 10 : 6"
                                                        class="page-label">
                                                        {{ getPageLabel(match) }}
                                                    </td>
                                                </tr>
                                                <tr [class.child-match-row]="match.is_child_row">
                                                    <!-- Nombre OP -->
                                                    <td>
                                                        <mat-form-field appearance="outline" class="custom-input">
                                                            <mat-label>Nombre Op.</mat-label>
                                                            <mat-icon matPrefix *ngIf="isMaterialUnavailable(match.material_id)"
                                                                color="warn" matTooltip="El material seleccionado ya no está disponible">
                                                                warning
                                                            </mat-icon>
                                                            <mat-select [(ngModel)]="match.material_id" [disabled]="completed" (closed)="clearSearch2()" (selectionChange)="onNombreOpChange($event.value, match)">
                                                                <div class="search-option">
                                                                    <div class="search-input-container mat-form-field-outlined">
                                                                        <mat-icon class="search-icon" aria-hidden="true">search</mat-icon>
                                                                        <input
                                                                            #searchInput2
                                                                            type="text"
                                                                            [(ngModel)]="searchTerm"
                                                                            (ngModelChange)="filterAtt()"
                                                                            (click)="$event.stopPropagation()"
                                                                            matInput
                                                                        />
                                                                    </div>
                                                                </div>
                                                                
                                                                <mat-option *ngFor="let material of filteredMateriales" [value]="material.id">
                                                                    {{material.nombre}}
                                                                    <span *ngIf="getMaterialSelectionCount(material.id, match) > 0">
                                                                        ({{ getMaterialSelectionCount(material.id, match) }} {{ getMaterialSelectionCount(material.id, match) === 1 ? 'vez' : 'veces' }})
                                                                    </span>
                                                                </mat-option>
                                                            </mat-select>
                                                        </mat-form-field>
                                                        <small class="text-muted d-block mt-n2 ms-2">
                                                            cantidad: {{ match.cantidad || 0 }}
                                                            <span *ngIf="match.cantidadAnterior !== undefined && match.cantidadAnterior !== null && match.cantidadAnterior !== match.cantidad"
                                                                class="text-danger ms-3" matTooltip="Cantidad anterior" [matTooltipPosition]="'right'">
                                                                anterior: {{ match.cantidadAnterior }}
                                                            </span>
                                                        </small>
                                                    </td>

                                                    <!-- Nombre Layout -->
                                                    <td>
                                                        <mat-form-field appearance="outline" class="custom-input">
                                                            <mat-label>Nombre Layout</mat-label>
                                                            <input matInput [(ngModel)]="match.nombre_layout" [disabled]="completed">
                                                        </mat-form-field>
                                                    </td>
                                                
                                                    <!-- Layout Dropdown -->
                                                    <td>
                                                        <mat-form-field appearance="outline" class="custom-input">
                                                            <mat-label>Layout</mat-label>
                                                            <mat-select [(ngModel)]="match.layout" [disabled]="completed">
                                                                <mat-option value="1x1">1x1</mat-option>
                                                                <mat-option value="2x1">2x1</mat-option>
                                                                <mat-option *ngIf="!hasProductWithEvenTintas()" value="3x1">3x1</mat-option>
                                                                <mat-option value="4x1">4x1</mat-option>
                                                                <mat-option value="1x2">1x2</mat-option>
                                                                <mat-option value="Banner">Banner</mat-option>
                                                                <mat-option value="2x2">2x2</mat-option>
                                                                <mat-option value="3x2">3x2</mat-option>
                                                                <mat-option value="4x2">4x2</mat-option>
                                                                <mat-option value="1x4">1x4</mat-option>
                                                            </mat-select>
                                                        </mat-form-field>
                                                    </td>
                                                
                                                    <!-- Producto -->
                                                    <td>
                                                        <mat-form-field appearance="outline" class="custom-input">
                                                            <mat-label>Producto</mat-label>
                                                            <mat-select [(ngModel)]="match.id_sku" [disabled]="completed" (selectionChange)="onSkuSelected(match)">
                                                                <mat-option *ngFor="let sku of selectedDocument.skuOdoo" [value]="sku.product_id">
                                                                    {{sku.planta}} - {{sku.descripcion}} - {{sku.tintas}}
                                                                </mat-option>
                                                            </mat-select>
                                                        </mat-form-field>
                                                    </td>
                                                
                                                    <td *ngIf="selectedDocument.mostrar_accesorios" class="accessory-label">
                                                        {{ match.selectedSku?.accessories?.length ? match.selectedSku.accessories[0].product_name : '' }}
                                                    </td>
                                                    <td *ngIf="selectedDocument.mostrar_accesorios">
                                                        <mat-form-field appearance="outline" class="custom-input"  style="width: 90px;">
                                                            <mat-label>Acc. 1</mat-label>
                                                            <input matInput type="number" [(ngModel)]="match.mult_accesorio1" [disabled]="completed">
                                                        </mat-form-field>
                                                    </td>
                                                    <td *ngIf="selectedDocument.mostrar_accesorios" class="accessory-label">
                                                        {{ match.selectedSku?.accessories?.length > 1 ? match.selectedSku.accessories[1].product_name : '' }}
                                                    </td>
                                                    <td *ngIf="selectedDocument.mostrar_accesorios">
                                                        <mat-form-field appearance="outline" class="custom-input"  style="width: 90px;">
                                                            <mat-label>Acc. 2</mat-label>
                                                            <input matInput type="number" [(ngModel)]="match.mult_accesorio2" [disabled]="completed">
                                                        </mat-form-field>
                                                    </td>

                                                    <td *ngIf="selectedDocument.type_match === 2" class="version-cell">
                                                        <mat-form-field appearance="outline" class="custom-input version-input">
                                                            <mat-label>Versión</mat-label>
                                                            <input matInput type="number" [(ngModel)]="match.version" [disabled]="completed">
                                                        </mat-form-field>
                                                    </td>
                                                
                                                    <!-- Acciones Global -->
                                                    <td *ngIf="selectedDocument.type_match !== 2" class="text-center action-cell">
                                                        <button *ngIf="!match.validando && (match.bitValido == null || match.bitValido == 0)" mat-flat-button
                                                            color="accent" class="validar-button ms-1 me-1" [disabled]="match.id_sku == 0 || completed"
                                                            (click)="validarSku(match.selectedSku, match, selectedDocument)">
                                                            Validar
                                                        </button>
                                                        <span *ngIf="match.validando" class="d-inline-flex align-items-center gap-1 text-muted me-1">
                                                            <span>Validando...</span>
                                                            <mat-progress-spinner color="primary" mode="indeterminate" [diameter]="18"
                                                                [strokeWidth]="3"></mat-progress-spinner>
                                                        </span>
                                                        <small *ngIf="match.bitValido === 1 && !match.validando" class="me-1">Válido</small>
                                                        <small *ngIf="match.bitValido === 0 && !match.validando" class="me-1">No válido</small>

                                                        <button *ngIf="match.archivo_respuesta_report != null" mat-icon-button color="primary"
                                                            (click)="openDialogArte(match.archivo_respuesta_report)" title="Ver reporte">
                                                            <mat-icon class="ms-1">article</mat-icon>
                                                        </button>
                                                
                                                        <button mat-icon-button color="accent" (click)="duplicateMatch(match)" [disabled]="completed" title="Duplicar">
                                                            <mat-icon>content_copy</mat-icon>
                                                        </button>
                                                        <button mat-icon-button color="warn" (click)="removeMatch(i)" [disabled]="completed" title="Eliminar">
                                                            <mat-icon>delete</mat-icon>
                                                        </button>
                                                    </td>
                                                
                                                    <!-- Acciones Por página -->
                                                    <td *ngIf="selectedDocument.type_match === 2" class="text-center action-cell">
                                                        <button *ngIf="!match.validando && (match.bitValido == null || match.bitValido == 0)" mat-flat-button
                                                            color="accent" class="validar-button me-1" [disabled]="match.id_sku == 0 || completed"
                                                            (click)="validarSku(match.selectedSku, match, selectedDocument)">
                                                            Validar
                                                        </button>
                                                        <span *ngIf="match.validando" class="d-inline-flex align-items-center gap-1 text-muted me-1">
                                                            <span>Validando...</span>
                                                            <mat-progress-spinner color="primary" mode="indeterminate" [diameter]="18"
                                                                [strokeWidth]="3"></mat-progress-spinner>
                                                        </span>
                                                        <small *ngIf="match.bitValido === 1 && !match.validando" class="me-1">Válido</small>
                                                        <small *ngIf="match.bitValido === 0 && !match.validando" class="me-1">No válido</small>

                                                        <button *ngIf="match.archivo_respuesta_report != null" mat-icon-button color="primary"
                                                            (click)="openDialogArte(match.archivo_respuesta_report)" title="Ver reporte">
                                                            <mat-icon class="ms-1">article</mat-icon>
                                                        </button>
                                                        
                                                        <button mat-icon-button color="primary"
                                                            (click)="openDialogArte(selectedDocument.archivo, match.page_index)"
                                                            title="Ver página {{ match.page_index || 1 }}">
                                                            <mat-icon>visibility</mat-icon>
                                                        </button>

                                                        <button *ngIf="!match.is_child_row" mat-icon-button color="primary" [disabled]="completed"
                                                            (click)="addPageChild(selectedDocument, match)" title="Añadir línea asociada a esta página">
                                                            <mat-icon>add</mat-icon>
                                                        </button>
                                                        <button *ngIf="match.is_child_row" mat-icon-button color="warn" [disabled]="completed"
                                                            (click)="removeAssociatedMatch(selectedDocument, match)" title="Eliminar subrenglón asociado">
                                                            <mat-icon>delete</mat-icon>
                                                        </button>
                                                    </td>
                                                </tr>
                                            </ng-container>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- PREPROYECTO -->
                <div *ngIf="!flagArtesPreproyecto" id="divPreproyecto">
                    <div class="row">
                        <div class="col-md-6">
                            <div class="row mt-1">
                                <div class="col-md-6">
                                    <h6><b>Resumen de la ODV</b></h6>
                                </div>
                            </div>
                            <div class="row mt-2">
                                <div class="col-md-6">
                                    <span><b>Cliente</b></span>
                                </div>
                                <div class="col-md-6">
                                    <span>{{dataPreproject.nombre_largo}}</span>
                                </div>
                            </div>
                            <div class="row mt-2">
                                <div class="col-md-6">
                                    <span><b>Folio</b></span>
                                </div>
                                <div class="col-md-6">
                                    <span>{{dataPreproject.folio}}</span>
                                </div>
                            </div>
                            <div class="row mt-2">
                                <div class="col-md-6">
                                    <span><b>Estrategia</b></span>
                                </div>
                                <div class="col-md-6">
                                    <span>{{strategy.name}}</span>
                                </div>
                            </div>
                            <div class="row mt-2">
                                <div class="col-md-6">
                                    <span><b>Distribución</b></span>
                                </div>
                                <div class="col-md-6">
                                    <span>{{dataPreproject.name_campana}}</span>
                                </div>
                            </div>
                            <div class="row mt-2">
                                <div class="col-md-6">
                                    <span><b>Área responsable</b></span>
                                </div>
                                <div class="col-md-6">
                                    <span>{{dataPreproject.area_responsable}}</span>
                                </div>
                            </div>

                            <div class="row mt-3">
                                <div class="col-md-12">
                                    <mat-form-field appearance="outline" class="custom-input">
                                        <mat-label>Fecha inicio - Fecha envío</mat-label>
                                        <mat-date-range-input [rangePicker]="picker" [disabled]="completed">
                                          <input matStartDate placeholder="Fecha Inicio" [(ngModel)]="dataPreproject.fecha_inicio">
                                          <input matEndDate placeholder="Fecha Fin" [(ngModel)]="dataPreproject.fecha_fin">
                                        </mat-date-range-input>
                                        <mat-datepicker-toggle matSuffix [for]="picker" [disabled]="completed"></mat-datepicker-toggle>
                                        <mat-date-range-picker #picker></mat-date-range-picker>
                                    </mat-form-field>
                                </div>  
                            </div>

                            <div class="row mt-3">
                                <div class="col-md-12">
                                    <mat-form-field appearance="outline" class="custom-input">
                                        <mat-label>Observaciones</mat-label>
                                        <input matInput [(ngModel)]="dataPreproject.observaciones" [disabled]="completed">
                                    </mat-form-field>
                                </div>  
                            </div>
                        </div>

                        <div class="col-md-6">
                            <div class="row mt-1" *ngIf="dataPreproject.status == 'error'">
                                <div class="col-md-12">   
                                    <label [ngClass]="'text-danger d-flex align-items-center ms-2'">
                                        <mat-icon>error</mat-icon>
                                        <strong class="ms-1">Error en últ. generación</strong>
                                    </label>
                                </div>
                            </div>

                            <div class="row mt-1" *ngIf="dataPreproject.status == 'error'">
                                <div class="col-md-12">   
                                    <label>{{dataPreproject.descripcion}}</label>
                                </div>
                            </div>

                            <div class="row mt-3">
                                <div class="col-md-6">
                                    <button mat-flat-button 
                                        class="bg-primary text-white fw-bold d-flex align-items-center justify-content-center w-100" 
                                        *ngIf="!completed"
                                        [disabled]="!dataPreproject.fecha_inicio || !dataPreproject.fecha_fin"
                                        [matTooltip]="(!dataPreproject.fecha_inicio || !dataPreproject.fecha_fin) ? 'Selecciona fecha de inicio y envío' : ''"
                                        (click)="savePreproyecto(dataPreproject)">
                                        Generar Preproyecto <mat-icon class="ms-1">output</mat-icon>
                                    </button>
                                </div>  
                                <div *ngIf="dataPreproject.archivo_layout" class="col-md-6 d-flex align-items-center">
                                    <button mat-flat-button class="bg-info text-white fw-bold d-flex align-items-center justify-content-center w-100" (click)="verLayout(dataPreproject.archivo_layout)">
                                        Layout <mat-icon class="ms-1">visibility</mat-icon>
                                    </button>
                                </div>
                            </div>

                            <div class="row mt-1">
                                <div *ngIf="dataPreproject.archivo_odt" class="col-md-6 d-flex align-items-center">
                                    <a mat-flat-button class="bg-success text-white fw-bold d-flex align-items-center justify-content-center w-100" href="{{dataPreproject.archivo_odt}}" target="_blank">
                                        ODT <mat-icon class="ms-1">visibility</mat-icon>
                                    </a>
                                </div> 
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</mat-dialog-content>

<div class="modal-footer mt-4 ms-5 me-5" [ngClass]="{'d-flex justify-content-between': !flagArtesPreproyecto}">
    <button *ngIf="!flagArtesPreproyecto" mat-flat-button class="bg-secondary text-white fw-bold d-flex align-items-center" [disabled]="flagArtesPreproyecto" [style.cursor]="flagArtesPreproyecto ? 'not-allowed' : 'pointer'" (click)="switchArtesPreproyecto(artes,dataPreproject,0,matches)">
        <mat-icon class="me-1">arrow_back</mat-icon>
        <label [style.cursor]="flagArtesPreproyecto ? 'not-allowed' : 'pointer'">Atras</label>
    </button>
    <div *ngIf="!flagArtesPreproyecto">
        <button *ngIf="data.strategy.bitPreproyecto != 1 && !completed && dataPreproject.archivo_layout" mat-flat-button class="bg-success text-white fw-bold d-flex align-items-center" (click)="cargaVoBoCliente()">
            <label style="cursor: pointer !important">Cargar para VoBo Cliente</label>
            <mat-icon class="ms-1">upload_file</mat-icon>
        </button>
    </div>
    <div *ngIf="flagArtesPreproyecto && selectedDocument?.matches?.length > 0">
        <button mat-flat-button class="bg-primary text-white fw-bold d-flex align-items-center" (click)="validarMatches()">
            <label style="cursor: pointer !important">Siguiente</label>
            <mat-icon class="ms-1">arrow_forward</mat-icon>
        </button>
    </div>
</div>